// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"_177672c","infoText":"_6998fe8","arrowContainer":"_9905f6d","arrow":"_d09ac3b","active":"_1029b53"};